// extracted by mini-css-extract-plugin
module.exports = {"size-1":"Logo_size-1__BSZ0D","size-2":"Logo_size-2___lOyM","size-3":"Logo_size-3__AfHWK"};